import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import CreateBook from './components/CreateBook';
import ManageBook from './components/ManageBook';
import ChapterViewer from './components/ChapterViewer';
import CreateChapter from './components/CreateChapter';
import ModerateBooks from './components/ModerateBooks';
import { UserProvider } from "./contexts/UserContext";

function App() {
    return (
        <Router>
            <UserProvider>
                <Routes>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/create-book" element={<CreateBook />} />
                    <Route path="/manage-book" element={<ManageBook />} />
                    <Route path="/chapter/:id" element={<ChapterViewer />} />
                    <Route path="/new-chapter" element={<CreateChapter />} />
                    <Route path="/moderate" element={<ModerateBooks />} /> 
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </UserProvider>
        </Router>
    );
}

export default App;